import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
//import styled, { css } from "styled-components"
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'




var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var From_Date_val;
var to_Date_val;


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };
  

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    
    this.getSubGroupId=this.getSubGroupId.bind(this);
    this.onApply = this.onApply.bind(this);
    this.onApplyData = this.onApplyData.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.SuccessConfirmoktoggle = this.SuccessConfirmoktoggle.bind(this);
    this.changeEAN = this.changeEAN.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getTaskList = this.getTaskList.bind(this);
    this.getMCCode = this.getMCCode.bind(this);
    this.getTaskTypeList = this.getTaskTypeList.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.changeArticleId = this.changeArticleId.bind(this);
    this.toggleNPICancel = this.toggleNPICancel.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onConfirmProduct = this.onConfirmProduct.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.onApply2 = this.onApply2.bind(this);
    this.changeLongName = this.changeLongName.bind(this);
    this.changeShortName = this.changeShortName.bind(this);
    this.changeDesc = this.changeDesc.bind(this);
    this.changeSellingPrice = this.changeSellingPrice.bind(this);
  

    /*this.ExcelDateToJSDate = this.ExcelDateToJSDate.bind(this);*/
    /*this.toShortFormat = this.toShortFormat.bind(this);*/
    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      showFromErr: false,
      showToErr: false,
      showFilter: false,
      ShowConfirmLoader: false,
      btnDisabled: true,
      isDisabledSearch: false,
      autoDesc: "",
      autoLongName: "",
      autoShortName: "",
      showConfirmError: false,
      autoCostPrice: "",
      autoSellingPrice: "",
      autoHsnCode: "",
      autoDesc: "",
      autoMargin: "",
      autoItemtype: "",
      article_id: "",
      mc_code_data: [],
      pack_size_uom: [],
      updated_fields: [],
      row_data: [],
      arr_data: [],
      po_to_grn :[["PO Number",  "PO Type" ,"Prod Code" ,"Prod Desc",  "MRP",  "Batch",  "PKD", "Short Qty" ,"PO Qty", "Short Close Time ","Short Close By"]],
      Polaris: [],
      task_type: [],
      pack_size1: [],
      variant1: [],
      task: [],
      store: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      mc_error: false,
      showTable: false,
      color_variant: false,
      applyShelfLife: "",
      applyPackUOM: "",
      applyShelfUOM: "",
      applyTax: "",
      applyVariant: "",
      color_mrp: false,
      color_shelf: false,
      color_mc_code: false,
      color_brand: false,
      color_tax: false,
      color_ean: false,
      color_product: false,
      product_name_val: "",
      applyMrp: "",
      status_type: "1",
      bill_number: "",
      party_code: "",
      sku: "",
      apply: true,
      store_id: "",
      filtered_orderData : "",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      request_id: "",
      taskId: "",
      packSize: "",
      constantmrp: "",
      longName: "",
      brand: "",
      mrp: "",
      ean: "",
      variant: "",
      shelf_life: "",
      image1: "",
      image2: "",
      image3: "",
      image4: "",
      image5: "",

      pack_unit: "",
      shelf_unit: "",
      showFetchDispatchData: false,

      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",
      subStore: [],
      fromdate: "",
      todate: "",
      apply1: true,
      shelf_life_data: [],
      modal: false,
      modal1: false,
      modal2: false,
      modalFailed: false,
      showPackSize: false,
      showShelfLife: false,
      color_packSize: false,
      new_brand: "",
      new_pack_size: "",
      new_shelf_life: "",
      new_tax_percentage: "",
      new_variant: "",
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      autoShelfLife: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""
    };
  }

  onPONumberChange = (evt) =>{
    this.setState({
      po_number: evt.target.value
    })

  }
  

  changeBrand = (evt) => {
    this.setState({
      brand_value: evt.target.value,
      brand: evt.target.value,
    });
  };
  changeArticleId = (evt) => {
    this.setState({
      article_id: evt.target.value,
    });
  };

  changeLongName = (evt) => {
    this.setState({
      autoLongName: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  changeShortName = (evt) => {
    this.setState({
      autoShortName: evt.target.value,
    });
  };

  changeDesc = (evt) => {
    this.setState({
      autoDesc: evt.target.value,
    });
  };

  changeSellingPrice = (evt) => {
    this.setState({
      autoSellingPrice: evt.target.value,
    });
  };

  changeCostPrice = (evt) => {
    this.setState({
      autoCostPrice: evt.target.value,
    });
  };
  onBillChange = (evt) => {
    this.setState({
      bill_number: evt.target.value,
    });
  };

  onUniqueCodeChange = (evt) => {
    this.setState({
      unique_code: evt.target.value,
    });
  };

  onSKUChange = (evt) => {
    this.setState({
      sku: evt.target.value,
    });
  };

  onCPChange = (evt) => {
    this.setState({
      cp_value: evt.target.value,
    });
  };


  viewImage() {
    //window.open('/view_image','_blank');
    this.props.history.push("/npi_request_data");
  }

  onApplyData() {
    this.setState({
      loader1: true,
      isDisabledApply: true,
    });

    if (
      (this.state.mc_code_value == "" ||
        this.state.mc_code_value == "undefined" ||
        this.state.mc_code_value == undefined) &&
      (this.state.article_id == "" ||
        this.state.article_id == "undefined" ||
        this.state.article_id == undefined)
    ) {
      this.setState({
        mc_error: true,
        loader1: false,
        isDisabledApply: false,
      });
      return false;
    } else {
      this.setState({
        mc_error: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "hsn_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          hsn_code: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          mc_code: this.state.mc_code_value,
          //brand: this.state.brand_value,
          article_id: this.state.article_id,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant_data: response.data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "shelf_life",
          mc_code: this.state.mc_code_value,
          article_id: this.state.article_id,
          //brand: this.state.brand_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          shelf_life_data: response.data.data,
          //loader1: false,
          isDisabledApply: false,
        });
      })
      .catch(function(error) {});

    this.onApply();
  }

  changeMCCode = (evt) => {
    this.setState({
      mc_error: false,
      mc_code_value: evt.target.value,
    });
  };

  changeEAN = (evt) => {
    this.setState({
      ean: evt.target.value,
    });
  };

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    this.fetchDispatch();
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }

  toggleNPICancel() {
    this.setState((prevState) => ({
      modal1: !prevState.modal1,
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  getVariant = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "variant",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          variant1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  radioChange(
    packSize,
    variant,
    shelf_life,
    product_id,
    product_name,
    mrp,
    tax_percentage,
    shelf_life_unit,
    pack_size_unit,
    long_name,
    short_name,
    hsn_code,
    desc,
    itemType,
    cost_price,
    selling_price,
    margin,
    brand,
    mc_code
  ) {
    this.setState({
      disabledVariant: true,
      disabledShelfLife: true,
      mc_code_value: mc_code,
      disabledProduct: true,
      disabledPackSize: true,
      autoLongName: long_name,
      autoShortName: short_name,
      brand: brand,
      autoHsnCode: hsn_code,
      autoDesc: desc,
      autoItemtype: itemType,
      autoCostPrice: cost_price,
      autoSellingPrice: selling_price,
      autoMargin: margin,
      autoPackSize: packSize,
      autoShelfLife: shelf_life,
      constantpacksize: packSize,
      constantvariant: variant,
      constantshelflife: shelf_life,
      constanttax: tax_percentage,
      tax_percentage1: tax_percentage,
      constantlongname: product_name,
      constantmrp1: mrp,
      shelf_unit: shelf_life_unit,
      pack_unit: pack_size_unit,
      autoVariant: variant,
      product_id: product_id,
      autoProductName: product_name,
      //mrp: mrp,
      pack_unit: pack_size_unit,
      shelf_unit: shelf_life_unit,
    });
  }

  getPacksize = () => {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "pack_size",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          pack_size1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  changeHSN = (e) => {
    const value = e.target.value;
    this.setState({
      hsn_value: value,
      autoHsnCode: value,
    });
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "tax_percentage",
          hsn_code: e.target.value,
          mc_code: this.state.mc_code_value,
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          tax_percentage: response.data.data,
          applyTax: response.data.data,
          tax_percentage1: response.data.data,
        });
      })
      .catch(function(error) {});
  };

  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  convertDate = (inputFormat) => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  var d = new Date(inputFormat)
  return [d.getFullYear(), pad(d.getMonth()+1),pad(d.getDate())].join('-')
}

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }
    
    var today = new Date();
    console.log(today)
     From_Date_val = this.convertDate(today);
      to_Date_val = this.convertDate(today);

    //From_Date_val = today;
    //to_Date_val = today;

    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

  /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
      }
      }
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        fromdate:today,
        todate:today,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        //  this.getSubGroupId();
        //this.fetchDispatch();
        //this.getStoreList();
        //this.getTaskList();
        //this.getMCCode();
        //this.getTaskTypeList();
        /*this.getVariant();
        this.getPacksize();*/
      }
    );

    //console.log("2n value")

    //localStorage.setItem('userName' , username);
    /*this.fetchDispatch();
      this.fetchDispatch();
      this.getStoreList();
      this.getTaskList();
      this.getPolarisList();
      this.getTaskTypeList();
      this.getVariant();
      this.getPacksize();*/
  }


  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
    this.setState({
      SuccessConfirmmodal: false,
    });

    window.location.reload();
    /*window.location.href="/putaway/printPutaway";*/
  }

  getMCCode() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "mc_code",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        console.log(response.data.data);

        this.setState({
          mc_code: true,
          mc_code_data: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getTaskTypeList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_types",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task_type: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getStoreList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "stores",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          store: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  getTaskList() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",

        {
          location: this.state.selectedLocation,
          api_type: "task_ids",
        },

        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => {
        this.setState({
          task: response.data.data,
        });
      })
      .catch(function(error) {});
  }

  onQuantityChangeBrand = (e) => {
    const value = e.target.value;
    this.setState({
      new_brand: value,
    });
  };

  onQuantityChangeShelf = (e) => {
    const value = e.target.value;
    this.setState({
      autoShelfLife: value,
      shelf_life: value,
    });
  };

  changePackSize = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.pack_size1.find(
        (item) => item.id == e.target.value
      );

      this.setState({
        applyPackSize: clickedOption.name,
        pack_unit: clickedOption.unit,
        autoPackSize: clickedOption.name,
        showPackSize: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showPackSize: false,
        });
      } else {
        this.setState({
          showPackSize: true,
        });
      }

      this.setState({
        //showPackSize: true,
        applyPackSize: "",
        pack_unit: "",
        autoPackSize: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "pack_size_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            pack_size_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeShelfLife = (e) => {
    const value = e.target.value;

    if (
      e.target.value !== "others" &&
      e.target.value != "" &&
      e.target.value != "undefined" &&
      e.target.value != "null"
    ) {
      const clickedOption = this.state.shelf_life_data.find(
        (item) => item.id == value
      );

      this.setState({
        applyShelfLife: clickedOption.name,
        shelf_unit: clickedOption.unit,
        autoShelfLife: clickedOption.name,
        showShelfLife: false,
      });
    } else {
      if (e.target.value == "") {
        this.setState({
          showShelfLife: false,
        });
      } else {
        this.setState({
          showShelfLife: true,
        });
      }
      this.setState({
        /*showShelfLife: true,*/
        applyShelfLife: "",
        shelf_unit: "",
        autoShelfLife: "",
      });

      axios
        .post(
          "http://" + url + "/fms/stockcheck/v1/products/",
          {
            api_type: "shelf_life_unit",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: Util.accessCookie("token"),
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.setState({
            shelf_life_uom: data.data,
          });
        })
        .catch(function(error) {});
    }
  };

  changeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
    });

    if (e.target.value == "others") {
      this.setState({
        showVariant: true,
        applyVariant: "",
        autoVariant: "",
      });
    } else {
      this.setState({
        showVariant: false,
        autoVariant: value,
      });
    }
  };

  changeSubGroup = (e) => {
    this.setState({
      sub_group: e.target.value
    })
  }

  changeManualPack = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackSize: value,
      autoPackSize: value,
    });
  };

  changeManualVariant = (e) => {
    const value = e.target.value;
    this.setState({
      applyVariant: value,
      autoVariant: value,
    });
  };

  changeManualShelf = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfLife: value,
      autoShelfLife: value,
    });
  };

  changeMrp1 = (e) => {
    const value = e.target.value;
    this.setState({
      applyMrp: value,
      mrp: value,
    });
  };

  changePackUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyPackUOM: value,
      pack_unit: value,
    });
  };

  /*changePackUOM=(e) =>{
     const value = e.target.value
    this.setState({
      applyPackUOM: value
    })


  }*/

  changeShlefUOM = (e) => {
    const value = e.target.value;
    this.setState({
      applyShelfUOM: value,
      shelf_unit: value,
    });
  };

  changeTax = (e) => {
    const value = e.target.value;
    this.setState({
      applyTax: value,
      tax_percentage1: value,
      color_tax: false,
    });
  };

  changeProductName = (e) => {
    const value = e.target.value;
    this.setState({
      autoProductName: value,
      color_product: false,
    });
  };

  onQuantityChangePackSize = (e) => {
    const value = e.target.value;
    this.setState({
      autoPackSize: value,
      packSize: value,
      color_packSize: false,
    });
  };

  changeMrp = (e) => {
    const value = e.target.value;
    this.setState({
      mrp: value,
      color_mrp: false,
    });
  };

  onQuantityChangeTax = (e) => {
    const value = e.target.value;
    this.setState({
      tax_percentage1: value,
      color_tax: false,
    });
  };

  onQuantityChangeVariant = (e) => {
    const value = e.target.value;
    this.setState({
      autoVariant: value,
      variant: value,
      color_variant: false,
    });
  };

  handleChange1 = (e) => {
    this.setState({
      store_id: e.target.value,
    });
  };

  handleChange2 = (e) => {
    this.setState({
      task_id: e.target.value,
    });
  };
  handleChange3 = (e) => {
    this.setState({
      polaris_id: e.target.value,
    });
  };
  handleChange4 = (e) => {
    this.setState({
      task_type_value: e.target.value,
    });
  };

  handleChange5 = (e) => {
    this.setState({
      status_type: e.target.value,
    });
  };

  getSubGroupId() {
    
    const payload = {
    
  };

API.post('/product/product_master/v1/subgroup/', { param: payload })
    .then((response) => response.data)

    .then((data) => {
     console.log(data);
      this.setState({ subStore: data.data });
    })

    .then(async () => {
      
    });
}

  assembleDispatchData = (dispatchData) => {
    
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        //brand: post.product_brand,
        po_number: post.po_number,
        po_type: post.po_type,
        product_code: post.product_code,
        product_desc: post.product_name,
        mrp: post.mrp,
        batch: post.batch,
        pkd: post.pkd,
        qty: post.total_qty,
        po_qty: post.po_qty,
        short_close_time: post.short_close_time,
        short_close_by: post.short_close_by
       
        
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };



  onCheck(
    taskid,
    mcCode,
    brand,
    longName,
    packsize,
    variant,
    mrp,
    ean,
    shelf_life,
    image1,
    image2,
    image3,
    image4,
    image5,
    tax_percentage,
    product_id,
    request_id,
    updated_fields,
    productName,
    variant_image,
    pack_size_image,
    task_detail_id
  ) {
    console.log(updated_fields);
    data_img = [];
    this.setState({
      apply: true,
      showTable: false,
      showFilter: false,
      updated_fields: updated_fields,
      color_variant: updated_fields.indexOf("variant") > -1 ? true : false,
      color_packSize: updated_fields.indexOf("pack_size") > -1 ? true : false,
      color_shelf: updated_fields.indexOf("shelf_life") > -1 ? true : false,
      color_product:
        updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false,
      color_mrp: updated_fields.indexOf("mrp") > -1 ? true : false,
      color_tax: updated_fields.indexOf("tax_percentage") > -1 ? true : false,
      color_brand: updated_fields.indexOf("brand") > -1 ? true : false,
      color_mc_code: updated_fields.indexOf("mc_code") > -1 ? true : false,
      color_ean: updated_fields.indexOf("ean") > -1 ? true : false,
      request_id: request_id,
      taskId: taskid,
      mcCode: mcCode,
      brand: brand,
      brand_value: brand,
      autoProductName: longName,
      autoPackSize: packsize,
      autoShelfLife: shelf_life,
      autoVariant: variant,
      packSize: packsize,
      product_name_val: productName,
      variant: variant,
      constantmrp: mrp,
      constantmrp1: mrp,
      //applyMrp: mrp,
      constantlongname: longName,
      constanttax: tax_percentage,
      constantpacksize: packsize,
      constantvariant: variant,
      constantshelflife: shelf_life,
      mrp: mrp,
      tax_percentage1: tax_percentage,
      ean: ean,
      shelf_life: shelf_life,
      image1: image1,
      image2: image2,
      image3: image3,
      image4: image4,
      image5: image5,
    });

    /*data_img = [*/

    if (image1) {
      var orderData1 = {};
      orderData1["image"] = image1;
      orderData1["text"] = "Brand";

      data_img.push(orderData1);
    }

    if (image3) {
      var orderData2 = {};
      orderData2["image"] = image3;
      orderData2["text"] = "MRP";

      data_img.push(orderData2);
    }

    if (image4) {
      var orderData3 = {};
      orderData3["image"] = image4;
      orderData3["text"] = "Shelf Life";

      data_img.push(orderData3);
    }

    if (image5) {
      var orderData4 = {};
      orderData4["image"] = image5;
      orderData4["text"] = "Product";

      data_img.push(orderData4);
    }

    if (variant_image) {
      var orderData4 = {};
      orderData4["image"] = variant_image;
      orderData4["text"] = "Variant";

      data_img.push(orderData4);
    }

    if (pack_size_image) {
      var orderData5 = {};
      orderData5["image"] = pack_size_image;
      orderData5["text"] = "Pack Size";

      data_img.push(orderData5);
    }

    console.log(data_img);

    /*{
        image: image1,
        text: 'Brand'
      },
      {
        image: image3,
        text: 'MRP'
      },
      {
        image: image4,
        text: 'Shelf Life'
      },
      {
        image: image5,
        text: 'Product'
      },
      {
        image: variant_image,
        text: 'Variant'
      },
      {
        image: pack_size_image,
        text: 'Pack Size'
      },
      
    ];*/

    localStorage.setItem("imgData", JSON.stringify(data_img));
    localStorage.setItem("longName", longName);
    localStorage.setItem("mrp", mrp);
    localStorage.setItem("ean", ean);
    localStorage.setItem("request_id", request_id);
    localStorage.setItem("task_id", taskid);
    localStorage.setItem("brand", brand);
    localStorage.setItem("task_detail_id", task_detail_id);
    localStorage.setItem("tax_percentage", tax_percentage);
    localStorage.setItem(
      "color_variant",
      updated_fields.indexOf("variant") > -1 ? true : false
    );
    localStorage.setItem(
      "color_packSize",
      updated_fields.indexOf("pack_size") > -1 ? true : false
    );
    localStorage.setItem(
      "color_shelf",
      updated_fields.indexOf("shelf_life") > -1 ? true : false
    );
    localStorage.setItem(
      "color_brand",
      updated_fields.indexOf("brand") > -1 ? true : false
    );
    localStorage.setItem(
      "color_mrp",
      updated_fields.indexOf("mrp") > -1 ? true : false
    );
    localStorage.setItem(
      "color_product",
      updated_fields.indexOf("polaris_item_long_name") > -1 ? true : false
    );

    /*if(product_id){
      this.setState({
        product_id: product_id
      })
      this.toggle2();

    }else{
      this.setState({
        product_id: ''
      })
      this.toggle1();
    }*/

    //window.location.href = '/npi_request_data';

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "shelf_life_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          shelf_life_uom: data.data,
        });
      })
      .catch(function(error) {});

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "pack_size_unit",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          pack_size_uom: data.data,
        });
      })
      .catch(function(error) {});

    this.viewImage();
  }

  onConfirm() {
    this.setState({
      ShowConfirmLoader: true,
    });
    if (
      this.state.autoLongName == "" ||
      this.state.autoShortName == "" ||
      this.state.autoHsnCode == "" ||
      this.state.autoDesc == "" ||
      this.state.autoItemtype == "" ||
      this.state.autoSellingPrice == "" ||
      this.state.autoCostPrice == "" ||
      this.state.autoMargin == "" ||
      this.state.ean == "" ||
      this.state.mrp == "" ||
      this.state.autoPackSize == "" ||
      this.state.brand == "" ||
      this.state.mrp == "" ||
      this.state.autoShelfLife == "" ||
      this.state.autoVariant == "" ||
      this.state.tax_percentage1 == ""
    ) {
      this.setState({
        showConfirmError: true,
        ShowConfirmLoader: false,
      });
      return false;
    } else {
      this.setState({
        showConfirmError: false,
      });
    }

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "status_update",
          task_id: this.state.request_id,
          polaris_item_long_name: this.state.autoLongName,
          polaris_item_short_name: this.state.autoShortName,
          hsn_code: this.state.autoHsnCode,
          mc_desc: this.state.autoDesc,
          item_type: this.state.autoItemtype,
          cost_price: this.state.autoCostPrice,
          sell_price: this.state.autoSellingPrice,
          margin: this.state.autoMargin,
          ean: this.state.ean,
          mrp: this.state.mrp,
          brand: this.state.brand,
          pack_size: this.state.autoPackSize,
          tax_percentage: this.state.tax_percentage1,
          shelf_life: this.state.autoShelfLife,
          variant: this.state.autoVariant,
          product_item_name: this.state.autoProductName,
          product_id: this.state.product_id,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,

          //"status": 3,
          remarks: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          success_message: data.message,
          ShowConfirmLoader: false,
        });
        this.toggle1();
        this.toggle();

        this.fetchDispatch();
      })
      .catch(function(error) {});

    this.setState((prevState) => ({
      autoShelfLife: "",
      applyShelfLife: "",
      hsn_code: [],
      variant_data: [],
      pack_size1: [],
      shelf_life_data: [],
      applyVariant: "",
      applyTax: "",
      applyPackSize: "",
      autoMargin: "",
      autoSellingPrice: "",
      autoCostPrice: "",
      autoHsnCode: "",
      autoLongName: "",
      autoShortName: "",
      autoDesc: "",
      autoItemtype: "",
      autoVariant: "",
      autoPackSize: "",
      autoProductName: "",
      tax_percentage1: "",
      mc_code_value: "",
      brand: "",
      ean: "",
    }));
  }

  onConfirmProduct() {
    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "status_update",
          task_id: this.state.request_id,
          ean: this.state.ean,
          mrp: this.state.mrp,
          brand: this.state.brand,
          pack_size: this.state.packSize,
          tax_percentage: this.state.tax_percentage1,
          shelf_life: this.state.shelf_life,
          variant: this.state.variant,
          product_item_name: this.state.autoProductName,
          product_id: this.state.product_id,

          //"status": 3,
          remarks: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          success_message: data.message,
        });
        this.toggle2();
        this.toggle();

        this.fetchDispatch();
      })
      .catch(function(error) {});
  }

  /*onApply2(){
      this.setState({
        ShowpopupLoader: true
      })
      console.log(this.state.row_data);
      var arrayCartData = this.state.row_data.filter(
      (item) => {
        if(this.state.applyTax && item.tax_percentage != this.state.applyTax) {
          return false
        }
        if(this.state.hsn_code && item.hsn_code != this.state.hsn_code) {
          return false
        }
        if(this.state.applyPackSize && item.pack_size != this.state.applyPackSize) {
          return false
        }
        if(this.state.pack_size_unit && item.pack_size_uom != this.state.pack_size_unit) {
          return false
        }
        if(this.state.shelf_life_unit && item.shelf_life_uom != this.state.shelf_life_unit) {
          return false
        }
        if(this.state.applyShelfLife && item.shelf_life != this.state.applyShelfLife) {
          return false
        }
        if(this.state.applyVariant && item.variant != this.state.applyVariant) {
          return false
        }
        if(this.state.applyMrp && item.mrp != this.state.applyMrp) {
          return false
        }

        return true;
      }
    );

      console.log(arrayCartData);

      this.setState({
        row_data: arrayCartData,
        ShowpopupLoader: false
      })
  }*/

  onApply(taskid) {
    this.setState({
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      // ShowpopupLoader: true,
      showTable: false,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
            showFilter: false,
          });
        } else {
          this.setState({
            showTable: true,
            showFilter: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }

  onApply2(taskid) {
    this.setState({
      row_data: [],
      apply: true,
      tax_percentage1: this.state.applyTax,
      autoVariant: this.state.applyVariant,
      autoShelfLife: this.state.applyShelfLife,
      autoPackSize: this.state.applyPackSize,
      ShowpopupLoader: true,
      showTable: true,
      isDisabledSearch: true,
      /*isDisabledApply: true*/
    });

    axios
      .post(
        "http://" + url + "/fms/stockcheck/v1/products/",
        {
          api_type: "all_products",
          mc_code: this.state.mc_code_value,
          //"brand": this.state.brand_value,
          hsn_code: this.state.hsn_value,
          mrp: this.state.applyMrp,
          pack_size: this.state.applyPackSize,
          shelf_life: this.state.applyShelfLife,
          variant: this.state.applyVariant,
          tax_percentage: this.state.applyTax,
          pack_size_unit: this.state.pack_unit,
          shelf_life_unit: this.state.shelf_unit,
          article_id: this.state.article_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            //Authorization: Util.accessCookie("token"),
          },
        }
      )
      .then((response) => response.data)
      .then((data) => {
        if (data.data.length == 0) {
          this.setState({
            showTable: false,
          });
        } else {
          this.setState({
            showTable: true,
          });
        }
        this.setState({
          row_data: data.data,
          ShowpopupLoader: false,
          isDisabledSearch: false,
          loader1: false,
          //isDisabledApply: false
        });
      })
      .catch(function(error) {});
  }


  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      "download": true,
      "to_date": to_Date_val,
      "from_date": From_Date_val,
  };

API.post('/receiving/receivingIntegrationReport/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
       
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href= data.data[0]
      })
      .catch(function (error) {});
  };


  fetchDispatch = (order_no) => {
    var url_val;

    if(!this.state.po_number){
      url_val = '/receiving/poShortReport?from_date=' + From_Date_val + '&to_date=' + to_Date_val;
    }else if(!to_Date_val || ! From_Date_val){
      url_val = '/receiving/poShortReport?po_number='+  this.state.po_number;
    }else{
      url_val =  '/receiving/poShortReport?from_date=' + From_Date_val + '&to_date=' + to_Date_val + '&po_number='+  this.state.po_number;
    }

      addAnalytics('Report', 'PO Short Report View');

      API.get(url_val)
      .then((response) => response.data)
      .then((data) => {
        
        this.setState({
          showFetchDispatchData: true,
          loading: false
        });
     

        if (data.length == 0) {
       
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,
            
          });
          return false;
        }
        var excelData = [];
        for(var i = 0; i< data.length; i++){
          var obj = {};

          obj['po_number'] = data[i].po_number;
          obj['po_type'] = data[i].po_type;
          obj['prod_code'] = data[i].product_code;
          obj['prod_desc'] = data[i].product_name;
          obj['mrp'] = data[i].mrp;
          obj['batch'] = data[i].batch;
          obj['pkd'] = data[i].pkd;
          obj['short_qty'] = data[i].total_qty;
          obj['po_qty'] = data[i].po_qty;
          obj['short_close_time'] = data[i].short_close_time;
          obj['short_close_by'] = data[i].short_close_by;

          excelData.push(obj)
        }

        this.setState({
          orderData: data,
          filtered_orderData : excelData,
          tableRowsMap: this.assembleDispatchData(data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});

  };


  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
    
  
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { modalFailed, modalReason } = this.state;
    const { SuccessConfirmmodal } = this.state;
    const { EditModal } = this.state;

    const dispatchData = {
      columns: [
       /* {

          label: "Brand",

          field: "brand",
          width: 100,
        },*/
        {

          label: "PO Number",

          field: "po_number",
          width: 140,
        },
        {

          label: "PO Type",

          field: "po_type",
          width: 140,
        },
        {
          label: "Prod Code",

          field: "product_code",
          width: 120,
        },
         {
          label: "Prod Desc",

          field: "product_desc",
          width: 150,
        },
        {
          label: "Mrp",

          field: "mrp",
          width: 100,
        },
        {
          label: "Batch",

          field: "batch",
          width: 120,
        },
         {
          label: "PKD",

          field: "pkd",
          width: 110,
        },
        {
          label: "Short Qty",

          field: "qty",
          width: 100,
        },

        {
          label: "PO Qty",

          field: "po_qty",
          width: 110,
        },

         {
          label: "Short Close Time",

          field: "short_close_time",
          width: 130,
        },

        {
          label: "Short Close By",

          field: "short_close_by",
          width: 130,
        },
        
        
       
      ],

      rows: this.state.tableRowsMap,
    };
   
    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
         
            <Overlay>
              <form className="form" onSubmit={handleSubmit}>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                    <span className="filter_title">Filters</span>
                  </div>
                 <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                      <span className="date_title">PO Number</span>
                      <div style={{ position: 'relative' }}>
                       <input type = "text" style={{height: 38}} className="form-control" placeholder= "PO Number" onChange={this.onPONumberChange}/>
                    </div>
                  </div>



              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">From Date</span>
                  <div style={{ position: 'relative' }}>
                      <DatePicker
                          selected={this.state.from_date}
                          onChange={this.FromDateChange}
                          className="ledger_fromdate"
                          placeholderText="From Date"
                          format='yyyy-MM-dd'
                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  </div>
                  {this.state.showFromErr && (
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  )}
                   {this.state.dateOrderError && (
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                  )}
              </div>




            
               <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">TO Date</span>
                  <div style={{ position: 'relative' }}>
              <DatePicker 
                          selected={this.state.to_date}
                          onChange={this.ToDateChange}
                          className="ledger_todate"
                placeholderText="To Date"
                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                      </div>
                      {this.state.showToErr &&
                        <span style={{color: 'red', fontSize: 11}}>Please Select To Date</span>
                        }

                       {this.state.dateRangeError &&
                          <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                        }
                    </div>
              
              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
        <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 6,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginRight: '10px', // Add some spacing between buttons
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View 
                  </Button>
               


                <Button
            type="button"
            className="btn btn-primary-outline"
            style={{
                cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                backgroundColor: '#FFFFFF',
                padding: "5px 10px",
                color: '#333333', // Set text color
                display: 'flex',   // Use flexbox to align image and text
                alignItems: 'center' // Center items vertically
            }}
            id="button_download"
            onClick={(e) => exportToCSV(this.state.filtered_orderData, "Receiving_short_close", this.state.po_to_grn)}
        >
            <img
                src={DownloadIcon}
                alt="Download"
                style={{ width: '22px' }} // Adjust size as needed
            />
            Download
        </Button>
         </ButtonToolbar>
              
                       
        </div>
            </form>
          </Overlay>

            {!this.state.showFetchDispatchData && (
          <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
             <img style={{width: '10%'}} src={EmptyDataIcon} />
              <p className="noDataTextStyle">
              Choose your filters from the available options. The data will display
            </p>
            <p className="noDataTextStyle2">
               here once the filters have been applied.
            </p>
          </div>


        )}

          {this.state.showFetchDispatchData && (
           
                         <div>
            <div>
              {this.state.po_number &&
               <div className="date-container">
                 {this.state.po_number}
                </div>
              }

                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                <div className="date-container">
                 {to_Date_val}
                </div>
              }

              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  displayEntries={true}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'PO Short Report', 'datatable_pagination_change' )}
                  striped
                  onSearch ={this.filterData}
                  bordered
                  data={dispatchData}
                />
              </div>
            </div>
            </div>
          )}
        </Card>

        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modal1}
          toggle={this.toggle1}
          style={{ maxWidth: 1045, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Request Creation
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 10 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            >
              <div style={{ width: "10%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    #{this.state.request_id}{" "}
                  </span>{" "}
                </span>
              </div>
              <div style={{ width: "11%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Task Id: </span>{" "}
                  <span> {this.state.taskId} </span>{" "}
                </span>
              </div>

              <div style={{ width: "21%", float: "left", textAlign: "center" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Product Name: </span>{" "}
                  <span> {this.state.product_name} </span>{" "}
                </span>
              </div>

              <div style={{ width: "12%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.constantmrp} </span>{" "}
                </span>
              </div>

              {data_img.length > 0 && (
                <div
                  style={{ width: "16%", float: "left", textAlign: "center" }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span
                      style={{ fontWeight: "bold", color: "rgb(62, 163, 252)" }}
                    >
                      {" "}
                    </span>{" "}
                    <a
                      style={{ fontWeight: "bold", color: "rgb(62, 163, 252)" }}
                      onClick={this.viewImage}
                    >
                      {" "}
                      View Images{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image2 && (
                <div
                  style={{
                    width: "10%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image2}>
                      {" "}
                      Invoice{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image3 && (
                <div
                  style={{
                    width: "12%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image3}>
                      {" "}
                      MRP{" "}
                    </a>{" "}
                  </span>
                </div>
              )}
              {this.state.image4 && (
                <div
                  style={{
                    width: "11%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image4}>
                      {" "}
                      Shelf Life{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image5 && (
                <div
                  style={{
                    width: "10%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image5}>
                      {" "}
                      Product{" "}
                    </a>{" "}
                  </span>
                </div>
              )}
            </div>

            <div
              style={{
                width: "100%",
                float: "left",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <div style={{ width: "13%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 12 }}>
                  <span style={{ fontWeight: "bold" }}> Mc Code </span>
                </span>
                <input
                  type="text"
                  placeholder="MC Code"
                  onChange={this.changeMCCode}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "95%",
                    fontSize: 12,
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
                {this.state.mc_error && (
                  <span style={{ fontSize: 10, color: "red" }}>
                    {" "}
                    Please Enter MC Code or Article Id{" "}
                  </span>
                )}
              </div>

              <div style={{ width: "13%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 12 }}>
                  <span style={{ fontWeight: "bold" }}> Article Id </span>
                </span>
                <input
                  type="text"
                  placeholder="Article Id"
                  onChange={this.changeArticleId}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "100%",
                    fontSize: 12,
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div
                style={{
                  width: "13%",
                  float: "left",
                  textAlign: "left",
                  display: "none",
                }}
              >
                <span style={{ fontSize: 12 }}>
                  <span style={{ fontWeight: "bold" }}> Brand </span>
                </span>
                <input
                  type="text"
                  placeholder="Brand"
                  value={this.state.brand_value}
                  onChange={this.changeBrand}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "100%",
                    fontSize: 12,
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>
              <div style={{ width: "11%", float: "left", textAlign: "left" }}>
                <ButtonToolbar className="modal__footer">
                  <Button
                    disabled={this.state.isDisabledApply}
                    style={{
                      backgroundColor: "#24d6a3",
                      marginTop: 21,
                      fontSize: 13,
                      paddingTop: 4,
                      height: 28,
                      color: "#fff",
                      marginLeft: 12,
                    }}
                    className="modal_ok"
                    onClick={this.fetchDispatchData}
                  >
                    {this.state.loader1 && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
            </div>

            {this.state.showFilter && (
              <div
                style={{
                  width: "100%",
                  float: "left",
                  marginTop: 12,
                  marginBottom: 10,
                }}
              >
                <div style={{ width: "7%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}> Mrp </span>
                  </span>
                  <input
                    type="text"
                    placeholder="MRP"
                    value={this.state.applyMrp}
                    onChange={this.changeMrp1}
                    style={{
                      padding: 4,
                      borderRadius: 2,
                      fontSize: 12,
                      width: "90%",
                      borderColor: "#dddddd",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                  />
                </div>

                <div style={{ width: "10%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}> HSN Code </span>
                  </span>
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{
                      fontSize: 11,
                      width: "90%",
                      height: 28,
                      paddingTop: 4,
                    }}
                    onChange={this.changeHSN}
                  >
                    <option value="">HSN Code</option>
                    {this.state.hsn_code.length > 0 &&
                      this.state.hsn_code.map((hsn_code) => {
                        return (
                          <option value={hsn_code.id}> {hsn_code.name}</option>
                        );
                      })}
                  </select>
                </div>
                <div style={{ width: "7%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}> Tax % </span>
                  </span>
                  <input
                    type="text"
                    placeholder="Tax%"
                    value={this.state.applyTax}
                    onChange={this.changeTax}
                    style={{
                      padding: 4,
                      borderRadius: 2,
                      fontSize: 12,
                      width: "90%",
                      borderColor: "#dddddd",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                  />
                </div>

                <div style={{ width: "11%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}> Pack Size </span>
                  </span>
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{
                      fontSize: 11,
                      width: "90%",
                      height: 28,
                      paddingTop: 4,
                    }}
                    onChange={this.changePackSize}
                  >
                    <option value="">Pack Size</option>
                    {/*<option value="others">Others</option>*/}
                    {this.state.pack_size1.length > 0 &&
                      this.state.pack_size1.map((pack_size) => {
                        return (
                          <option value={pack_size.id}>
                            {" "}
                            {pack_size.name} {pack_size.unit}
                          </option>
                        );
                      })}
                  </select>
                </div>

                {this.state.showPackSize && (
                  <div
                    style={{ width: "9%", float: "left", textAlign: "left" }}
                  >
                    <span style={{ fontSize: 12 }}>
                      <span style={{ fontWeight: "bold" }}> Pack Size </span>
                    </span>
                    <input
                      type="text"
                      placeholder="Pack Size"
                      onChange={this.changeManualPack}
                      style={{
                        padding: 4,
                        borderRadius: 2,
                        fontSize: 12,
                        width: "90%",
                        borderColor: "#dddddd",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }}
                    />
                  </div>
                )}
                {this.state.showPackSize && (
                  <div
                    style={{ width: "8%", float: "left", textAlign: "left" }}
                  >
                    <span style={{ fontSize: 12 }}>
                      <span style={{ fontWeight: "bold" }}> UOM </span>
                    </span>

                    {/*<input
                  type="text"
                  placeholder="UOM"
                  onChange={this.changePackUOM}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    fontSize: 12,
                    width: "90%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />*/}

                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{
                        fontSize: 11,
                        width: "90%",
                        height: 28,
                        paddingTop: 4,
                      }}
                      onChange={this.changePackUOM}
                    >
                      <option style={{ fontSize: 10 }} value="">
                        UOM
                      </option>
                      {this.state.pack_size_uom.length > 0 &&
                        this.state.pack_size_uom.map((pack_size_uom) => {
                          return (
                            <option value={pack_size_uom.name}>
                              {" "}
                              {pack_size_uom.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                )}

                <div style={{ width: "10%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}>Shelf Life </span>
                  </span>
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{
                      fontSize: 11,
                      width: "90%",
                      height: 28,
                      paddingTop: 4,
                    }}
                    onChange={this.changeShelfLife}
                  >
                    <option value="">Shelf Life</option>
                    {/*<option value="others">Others</option>*/}
                    {this.state.shelf_life_data.length > 0 &&
                      this.state.shelf_life_data.map((shelf_life) => {
                        return (
                          <option value={shelf_life.id}>
                            {" "}
                            {shelf_life.name} {shelf_life.unit}
                          </option>
                        );
                      })}
                  </select>
                </div>

                {this.state.showShelfLife && (
                  <div
                    style={{ width: "10%", float: "left", textAlign: "left" }}
                  >
                    <span style={{ fontSize: 12 }}>
                      <span style={{ fontWeight: "bold" }}> Shelf Life </span>
                    </span>

                    <input
                      type="text"
                      placeholder="Shelf Life"
                      onChange={this.changeManualShelf}
                      style={{
                        padding: 4,
                        borderRadius: 2,
                        width: "90%",
                        fontSize: 12,
                        borderColor: "#dddddd",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }}
                    />
                  </div>
                )}

                {this.state.showShelfLife && (
                  <div
                    style={{ width: "8%", float: "left", textAlign: "left" }}
                  >
                    <span style={{ fontSize: 12 }}>
                      <span style={{ fontWeight: "bold" }}> UOM </span>
                    </span>
                    {/*<input
                  type="text"
                  placeholder="UOM"
                  onChange={this.changeShlefUOM}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    fontSize: 12,
                    width: "90%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />*/}

                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{
                        fontSize: 11,
                        width: "90%",
                        height: 28,
                        paddingTop: 4,
                      }}
                      onChange={this.changeShlefUOM}
                    >
                      <option value="">UOM</option>
                      {this.state.shelf_life_uom.length > 0 &&
                        this.state.shelf_life_uom.map((shelf_life_uom) => {
                          return (
                            <option value={shelf_life_uom.name}>
                              {" "}
                              {shelf_life_uom.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                )}

                <div style={{ width: "10%", float: "left", textAlign: "left" }}>
                  <span style={{ fontSize: 12 }}>
                    <span style={{ fontWeight: "bold" }}> Variant </span>
                  </span>
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{
                      fontSize: 11,
                      width: "90%",
                      height: 28,
                      paddingTop: 4,
                    }}
                    onChange={this.changeVariant}
                  >
                    <option value="">Variant</option>
                    {/*<option value="others">Others</option>*/}
                    {this.state.variant_data.length > 0 &&
                      this.state.variant_data.map((variant) => {
                        return (
                          <option value={variant.name}> {variant.name}</option>
                        );
                      })}
                  </select>
                </div>

                {this.state.showVariant && (
                  <div
                    style={{ width: "9%", float: "left", textAlign: "left" }}
                  >
                    <span style={{ fontSize: 12 }}>
                      <span style={{ fontWeight: "bold" }}> Variant </span>
                    </span>

                    <input
                      type="text"
                      placeholder="Variant"
                      onChange={this.changeManualVariant}
                      style={{
                        padding: 4,
                        borderRadius: 2,
                        width: "90%",
                        fontSize: 12,
                        borderColor: "#dddddd",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }}
                    />
                  </div>
                )}

                <div style={{ width: "9%", float: "left", textAlign: "left" }}>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      disabled={this.state.isDisabledSearch}
                      style={{
                        backgroundColor: "#24d6a3",
                        marginTop: 21,
                        fontSize: 13,
                        paddingTop: 4,
                        height: 26,
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.onApply2}
                    >
                      {this.state.ShowpopupLoader && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Apply
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            )}

            {this.state.apply && (
              <div style={{ width: "100%", float: "left" }}>
                <div
                  style={{
                    width: "100%",
                    float: "left",
                    marginTop: 12,
                    marginBottom: 10,
                    display: "none",
                  }}
                >
                  <div
                    style={{ width: "31%", float: "left", textAlign: "left" }}
                  >
                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{ fontSize: 13 }}
                      onChange={this.handleChange1}
                    >
                      <option value="">Select Pack Size</option>
                      {this.state.pack_size1.length > 0 &&
                        this.state.pack_size1.map((pack_size) => {
                          return (
                            <option value={pack_size.id}>
                              {" "}
                              {pack_size.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div
                    style={{
                      width: "22%",
                      float: "left",
                      textAlign: "right",
                      marginLeft: 12,
                    }}
                  >
                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{ fontSize: 13 }}
                      onChange={this.handleChange1}
                    >
                      <option value="">Select Variant</option>
                      {this.state.variant1.length > 0 &&
                        this.state.variant1.map((variant) => {
                          return (
                            <option value={variant.id}> {variant.name}</option>
                          );
                        })}
                    </select>
                  </div>

                  <div
                    style={{
                      width: "22%",
                      float: "left",
                      textAlign: "right",
                      display: "none",
                    }}
                  >
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{
                          backgroundColor: "#24d6a3",
                          color: "#fff",
                          marginLeft: 12,
                        }}
                        className="modal_ok"
                        disabled={this.state.disable_submit_button}
                        onClick={this.processData}
                      >
                        {this.state.ShowEditLoader && (
                          <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        )}
                        Apply
                      </Button>
                    </ButtonToolbar>
                  </div>
                </div>

                {this.state.showTable && (
                  <table
                    className="table table-bordered table-hover list_table table-container table-scroll small-first-col"
                    id="tab_logic"
                  >
                    <thead className="list_head" style={{ textAlign: "left" }}>
                      <tr>
                        <th> Action </th>

                        <th>MC Code</th>
                        <th>Brand</th>
                        <th> Item Code </th>
                        <th> Long Name </th>
                        <th> Short Name </th>
                        <th> Shelf Life </th>
                        <th> Pack Size </th>
                        <th> Variant </th>
                        <th> Mrp </th>
                        <th> Tax % </th>
                      </tr>
                    </thead>
                    <tbody className="list_body body-half-screen">
                      {this.state.row_data.length > 0 &&
                        this.state.row_data.map((item, index) => (
                          <tr>
                            <td>
                              {" "}
                              <input
                                type="radio"
                                name="action"
                                onChange={() =>
                                  this.radioChange(
                                    item.pack_size,
                                    item.variant,
                                    item.shelf_life,
                                    item.product_id,
                                    item.polaris_item_long_name,
                                    item.mrp,
                                    item.tax_percentage,
                                    item.shelf_life_unit,
                                    item.pack_size_unit,
                                    item.polaris_item_long_name,
                                    item.polaris_item_short_name,
                                    item.hsn_code,
                                    item.material_description,
                                    item.item_type,
                                    item.cost_price,
                                    item.sell_price,
                                    item.margin,
                                    item.brand,
                                    item.mc_code
                                  )
                                }
                              />{" "}
                            </td>
                            <td>{item.mc_code}</td>

                            <td>{item.brand}</td>
                            <td> {item.polaris_item_code}</td>
                            <td>{item.polaris_item_long_name}</td>
                            <td>{item.polaris_item_short_name}</td>
                            <td>
                              {item.shelf_life} {item.shelf_life_unit}
                            </td>
                            <td>
                              {item.pack_size} {item.pack_size_unit}
                            </td>
                            <td>{item.variant}</td>
                            <td>{item.mrp}</td>
                            <td>{item.tax_percentage}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}

                <div style={{ display: "none" }}>
                  <span
                    style={{
                      fontSize: 14,
                      width: "100%",
                      float: "left",
                      textAlign: "left",
                      paddingLeft: 10,
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}> Product Master </span>
                  </span>
                </div>

                <Card
                  style={{
                    backgroundColor: "aliceblue",
                    display: "none",
                    paddingBottom: 0,
                    marginBottom: 12,
                  }}
                >
                  <CardBody style={{ padding: 8 }}>
                    <div style={{ width: "100%", float: "left" }}>
                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> EAN </span>
                        </span>
                        <input
                          type="text"
                          placeholder="EAN"
                          defaultValue={this.state.ean}
                          onChange={this.changeTesterQty}
                          disabled={true}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MRP </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Mrp"
                          value={this.state.constantmrp1}
                          onChange={this.changeMrp}
                          disabled
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {this.state.pack_unit ? (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pack Size ({this.state.pack_unit}){" "}
                            </span>
                          ) : (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pack Size {this.state.pack_unit}{" "}
                            </span>
                          )}
                        </span>
                        <input
                          type="text"
                          placeholder="Pack Size"
                          disabled
                          value={this.state.constantpacksize}
                          onChange={this.onQuantityChangePackSize}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Variant </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Variant"
                          disabled
                          value={this.state.constantvariant}
                          onChange={this.onQuantityChangeVariant}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {this.state.shelf_unit ? (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Shelf Life ({this.state.shelf_unit}){" "}
                            </span>
                          ) : (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Shelf Life {this.state.shelf_unit}{" "}
                            </span>
                          )}
                        </span>
                        <input
                          type="text"
                          placeholder="Shelf Life"
                          disabled
                          value={this.state.constantshelflife}
                          onChange={this.onQuantityChangeShelf}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Product Name{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Product Name"
                          disabled
                          value={this.state.constantlongname}
                          onChange={this.changeProductName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Tax % </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Tax %"
                          disabled
                          value={this.state.constanttax}
                          onChange={this.changeProductName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <div>
                  <span
                    style={{
                      fontSize: 14,
                      width: "100%",
                      float: "left",
                      textAlign: "left",
                      paddingLeft: 10,
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}> Request Data </span>
                  </span>
                </div>

                <Card
                  style={{ backgroundColor: "aliceblue", paddingBottom: 0 }}
                >
                  <CardBody style={{ padding: 8 }}>
                    <div style={{ width: "100%", float: "left" }}>
                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MC Code </span>
                        </span>
                        <input
                          type="text"
                          placeholder="MC Code"
                          value={this.state.mc_code_value}
                          onChange={this.changeMCCode}
                          disabled={false}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "11%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Brand </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Brand"
                          value={this.state.brand}
                          disabled={false}
                          onChange={this.changeBrand}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> EAN </span>
                        </span>
                        <input
                          type="text"
                          placeholder="EAN"
                          value={this.state.ean}
                          onChange={this.changeEAN}
                          disabled={false}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "7%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MRP </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Mrp"
                          value={this.state.mrp}
                          disabled={false}
                          onChange={this.changeMrp}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {this.state.pack_unit ? (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pack Size ({this.state.pack_unit}){" "}
                            </span>
                          ) : (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Pack Size {this.state.pack_unit}{" "}
                            </span>
                          )}
                        </span>
                        <input
                          type="text"
                          placeholder="Pack Size"
                          disabled={false}
                          value={this.state.autoPackSize}
                          onChange={this.onQuantityChangePackSize}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "8%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> UOM </span>
                        </span>
                        <select
                          className="form-control"
                          value={this.state.pack_unit}
                          style={{
                            fontSize: 11,
                            width: "90%",
                            height: 32,
                            paddingTop: 4,
                          }}
                          onChange={this.changePackUOM}
                        >
                          <option style={{ fontSize: 10 }} value="">
                            UOM
                          </option>
                          {this.state.pack_size_uom.length > 0 &&
                            this.state.pack_size_uom.map((pack_size_uom) => {
                              return (
                                <option value={pack_size_uom.name}>
                                  {" "}
                                  {pack_size_uom.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>

                      <div
                        style={{
                          width: "11%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Variant </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Variant"
                          disabled={false}
                          value={this.state.autoVariant}
                          onChange={this.onQuantityChangeVariant}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {this.state.shelf_unit ? (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Shelf Life ({this.state.shelf_unit}){" "}
                            </span>
                          ) : (
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Shelf Life {this.state.shelf_unit}{" "}
                            </span>
                          )}
                        </span>
                        <input
                          type="text"
                          placeholder="Shelf Life"
                          disabled={false}
                          value={this.state.autoShelfLife}
                          onChange={this.onQuantityChangeShelf}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "8%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> UOM </span>
                        </span>
                        <select
                          className="form-control"
                          value={this.state.shelf_unit}
                          style={{
                            fontSize: 11,
                            width: "90%",
                            height: 32,
                            paddingTop: 4,
                          }}
                          onChange={this.changeShlefUOM}
                        >
                          <option style={{ fontSize: 10 }} value="">
                            UOM
                          </option>
                          {this.state.shelf_life_uom.length > 0 &&
                            this.state.shelf_life_uom.map((shelf_life_uom) => {
                              return (
                                <option value={shelf_life_uom.name}>
                                  {" "}
                                  {shelf_life_uom.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>

                      {/*<div style={{width: '15%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 13, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Product Name </span></span>
                 <input
                  type="text"
                  placeholder="Product Name"
                  
                  value={this.state.autoProductName}
                  onChange={this.changeProductName}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "90%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>*/}
                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Tax % </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Tax Percentage"
                          disabled={false}
                          value={this.state.tax_percentage1}
                          onChange={this.onQuantityChangeTax}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>

                  <CardBody style={{ padding: 8 }}>
                    <div style={{ width: "100%", float: "left" }}>
                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> HSN Code </span>
                        </span>
                        <input
                          type="text"
                          placeholder="HSN Code"
                          value={this.state.autoHsnCode}
                          onChange={this.changeHSNCode}
                          disabled={false}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "16%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Long Name{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Long Name"
                          value={this.state.autoLongName}
                          onChange={this.changeLongName}
                          disabled={false}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "16%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Short Name{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Short Name"
                          value={this.state.autoShortName}
                          disabled={false}
                          onChange={this.changeShortName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "17%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MC Desc </span>
                        </span>
                        <input
                          type="text"
                          placeholder="MC Desc"
                          defaultValue={this.state.autoDesc}
                          onChange={this.changeDesc}
                          disabled={false}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Item type{" "}
                          </span>
                        </span>
                        {/*<input
                  type="text"
                  placeholder="Item type"
                  value={this.state.autoItemtype}
                  disabled={false}
                  onChange={this.changeItemType}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "95%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />*/}
                        <select
                          className="form-control"
                          value={this.state.autoItemtype}
                          style={{
                            fontSize: 13,
                            width: "90%",
                            height: 32,
                            paddingTop: 4,
                          }}
                          onChange={this.changeItemType}
                        >
                          <option style={{ fontSize: 10 }} value="">
                            Item type
                          </option>
                          <option style={{ fontSize: 10 }} value="Food">
                            Food
                          </option>
                          <option style={{ fontSize: 10 }} value="Non Food">
                            Non Food
                          </option>
                        </select>
                      </div>

                      <div
                        style={{
                          width: "9%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Cost Price{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Cost Price"
                          disabled={false}
                          value={this.state.autoCostPrice}
                          onChange={this.changeCostPrice}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "11%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Selling Price{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Selling Price"
                          disabled={false}
                          value={this.state.autoSellingPrice}
                          onChange={this.changeSellingPrice}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "95%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "10%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          {" "}
                          <span style={{ fontWeight: "bold" }}> Margin </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Margin"
                          disabled={false}
                          value={this.state.autoMargin}
                          onChange={this.changeMargin}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      {/* <div style={{width: '8%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 13, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> UOM </span></span>
                <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 11, width:'90%' , height: 32, paddingTop: 4 }}
                    onChange={this.changePackUOM}
                  >
                    <option style={{fontSize: 10}} value="">UOM</option>
                    {
                      this.state.pack_size_uom.length > 0 &&
                      this.state.pack_size_uom.map((pack_size_uom) => {
                        return (
                          <option value={pack_size_uom.name}>
                            {" "}
                            {pack_size_uom.name}
                          </option>
                        );
                      })}
                  </select>
              </div>*/}

                      {/* <div style={{width: '7%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 13, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> UOM </span></span>
                <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 11, width:'90%' , height: 32, paddingTop: 4 }}
                    onChange={this.changePackUOM}
                  >
                    <option style={{fontSize: 10}} value="">UOM</option>
                    {
                      this.state.pack_size_uom.length > 0 &&
                      this.state.pack_size_uom.map((pack_size_uom) => {
                        return (
                          <option value={pack_size_uom.name}>
                            {" "}
                            {pack_size_uom.name}
                          </option>
                        );
                      })}
                  </select>
              </div>*/}

                      {/*<div style={{width: '15%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 13, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Product Name </span></span>
                 <input
                  type="text"
                  placeholder="Product Name"
                  
                  value={this.state.autoProductName}
                  onChange={this.changeProductName}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "90%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>*/}
                    </div>
                  </CardBody>

                  {this.state.showConfirmError && (
                    <CardBody style={{ padding: 8 }}>
                      <div style={{ width: "100%", float: "left" }}>
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          {" "}
                          Please Fill All Detail{" "}
                        </span>
                      </div>
                    </CardBody>
                  )}
                </Card>
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <Button
                  style={{ backgroundColor: "#ddd", color: "#fff" }}
                  className="modal_ok"
                  onClick={this.toggleNPICancel}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.onConfirm}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Confim
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modal2}
          toggle={this.toggle2}
          style={{ maxWidth: 1000, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Request Creation
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div
              className="req_type"
              style={{
                width: "100%",
                float: "left",
                paddingBottom: 12,
                borderBottomWidth: 1,
                borderColor: "#ccc",
              }}
            >
              <div style={{ width: "10%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Task Id: </span>{" "}
                  <span> {this.state.taskId} </span>{" "}
                </span>
              </div>

              <div style={{ width: "25%", float: "left", textAlign: "center" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Brand: </span>{" "}
                  <span> {this.state.brand} </span>{" "}
                </span>
              </div>

              <div style={{ width: "15%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.constantmrp} </span>{" "}
                </span>
              </div>

              {data_img.length > 0 && (
                <div
                  style={{ width: "16%", float: "left", textAlign: "center" }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span
                      style={{ fontWeight: "bold", color: "rgb(62, 163, 252)" }}
                    >
                      {" "}
                    </span>{" "}
                    <a
                      style={{ fontWeight: "bold", color: "rgb(62, 163, 252)" }}
                      onClick={this.viewImage}
                    >
                      {" "}
                      View Images{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image2 && (
                <div
                  style={{
                    width: "15%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image2}>
                      {" "}
                      Invoice{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image3 && (
                <div
                  style={{
                    width: "15%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image3}>
                      {" "}
                      Mrp{" "}
                    </a>{" "}
                  </span>
                </div>
              )}
              {this.state.image4 && (
                <div
                  style={{
                    width: "15%",
                    float: "left",
                    textAlign: "left",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image4}>
                      {" "}
                      Shelf Life{" "}
                    </a>{" "}
                  </span>
                </div>
              )}

              {this.state.image5 && (
                <div
                  style={{
                    width: "15%",
                    float: "left",
                    textAlign: "center",
                    display: "none",
                  }}
                >
                  <span style={{ fontSize: 15 }}>
                    <span style={{ fontWeight: "bold" }}> </span>{" "}
                    <a target="_blank" href={this.state.image5}>
                      {" "}
                      Product{" "}
                    </a>{" "}
                  </span>
                </div>
              )}
            </div>

            <div
              style={{
                width: "100%",
                float: "left",
                marginTop: 12,
                marginBottom: 10,
              }}
            >
              <div style={{ width: "28%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Mc Code </span>
                </span>
                <input
                  type="text"
                  placeholder="MC Code"
                  disabled={true}
                  value={this.state.mcCode}
                  onChange={this.changeMCCode}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "80%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    color:
                      this.state.color_mc_code == true ? "orange" : "inherit",
                  }}
                />
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Brand </span>
                </span>
                <input
                  type="text"
                  placeholder="Brand"
                  disabled={true}
                  value={this.state.brand}
                  onChange={this.changeBrand}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "80%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div
                style={{
                  width: "22%",
                  float: "left",
                  textAlign: "right",
                  display: "none",
                }}
              >
                <ButtonToolbar className="modal__footer">
                  <Button
                    style={{
                      backgroundColor: "#24d6a3",
                      color: "#fff",
                      marginLeft: 12,
                    }}
                    className="modal_ok"
                    disabled={this.state.disable_submit_button}
                    onClick={this.onApply}
                  >
                    {this.state.ShowEditLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Apply
                  </Button>
                </ButtonToolbar>
              </div>
            </div>

            {this.state.apply1 && (
              <div style={{ width: "100%", float: "left" }}>
                <div
                  style={{
                    width: "100%",
                    float: "left",
                    marginTop: 12,
                    marginBottom: 10,
                    display: "none",
                  }}
                >
                  <div
                    style={{ width: "31%", float: "left", textAlign: "left" }}
                  >
                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{ fontSize: 13 }}
                      onChange={this.handleChange1}
                    >
                      <option value="0">Select Pack Size</option>
                      {this.state.pack_size1.length > 0 &&
                        this.state.pack_size1.map((pack_size) => {
                          return (
                            <option value={pack_size.id}>
                              {" "}
                              {pack_size.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div
                    style={{
                      width: "22%",
                      float: "left",
                      textAlign: "right",
                      marginLeft: 12,
                    }}
                  >
                    <select
                      className="form-control"
                      value={this.state.value}
                      style={{ fontSize: 13 }}
                      onChange={this.handleChange1}
                    >
                      <option value="0">Select Variant</option>
                      {this.state.variant1.length > 0 &&
                        this.state.variant1.map((variant) => {
                          return (
                            <option value={variant.id}> {variant.name}</option>
                          );
                        })}
                    </select>
                  </div>

                  <div
                    style={{
                      width: "22%",
                      float: "left",
                      textAlign: "right",
                      display: "none",
                    }}
                  >
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{
                          backgroundColor: "#24d6a3",
                          color: "#fff",
                          marginLeft: 12,
                        }}
                        className="modal_ok"
                        disabled={this.state.disable_submit_button}
                        onClick={this.processData}
                      >
                        {this.state.ShowEditLoader && (
                          <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        )}
                        Apply
                      </Button>
                    </ButtonToolbar>
                  </div>
                </div>

                <table
                  style={{ display: "none" }}
                  className="table table-bordered table-hover"
                  id="tab_logic"
                >
                  <thead style={{ textAlign: "left" }}>
                    <tr>
                      <th> Action </th>

                      <th>MC Code</th>
                      <th>Brand</th>
                      <th> Item Code </th>
                      <th> Long Name </th>
                      <th> Short Name </th>
                      <th> Shelf Life </th>
                      <th> Pack Size </th>
                      <th> Variant </th>
                      <th> Mrp </th>
                      <th> Tax % </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.row_data.length > 0 &&
                      this.state.row_data.map((item, index) => (
                        <tr>
                          <td>
                            {" "}
                            <input
                              type="radio"
                              name="action"
                              onChange={() =>
                                this.radioChange(
                                  item.pack_size,
                                  item.variant,
                                  item.shelf_life,
                                  item.product_id,
                                  item.polaris_item_long_name,
                                  item.mrp
                                )
                              }
                            />{" "}
                          </td>
                          <td>{item.mc_code}</td>
                          <td>{item.brand}</td>
                          <td> {item.polaris_item_code}</td>
                          <td>{item.polaris_item_long_name}</td>
                          <td>{item.polaris_item_short_name}</td>
                          <td>{item.shelf_life}</td>
                          <td>{item.pack_size}</td>
                          <td>{item.variant}</td>
                          <td>{item.mrp}</td>
                          <td>{item.tax_percentage}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <div style={{ display: "none" }}>
                  <span
                    style={{
                      fontSize: 14,
                      width: "100%",
                      float: "left",
                      textAlign: "left",
                      paddingLeft: 10,
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}> Product Master </span>
                  </span>
                </div>

                <Card
                  style={{
                    backgroundColor: "aliceblue",
                    display: "none",
                    paddingBottom: 0,
                    marginBottom: 12,
                  }}
                >
                  <CardBody style={{ padding: 8 }}>
                    <div style={{ width: "100%", float: "left" }}>
                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> EAN </span>
                        </span>
                        <input
                          type="text"
                          placeholder="EAN"
                          defaultValue={this.state.ean}
                          onChange={this.changeTesterQty}
                          disabled={true}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MRP </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Mrp"
                          value={this.state.constantmrp1}
                          onChange={this.changeMrp}
                          disabled
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Pack Size{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Pack Size"
                          disabled
                          value={this.state.constantpacksize}
                          onChange={this.onQuantityChangePackSize}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Variant </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Variant"
                          disabled
                          value={this.state.constantvariant}
                          onChange={this.onQuantityChangeVariant}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Shelf Life{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Shelf Life"
                          disabled
                          value={this.state.constantshelflife}
                          onChange={this.onQuantityChangeShelf}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "15%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Product Name{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Product Name"
                          disabled
                          value={this.state.constantlongname}
                          onChange={this.changeProductName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Tax % </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Tax %"
                          disabled
                          value={this.state.constanttax}
                          onChange={this.changeProductName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <div>
                  <span
                    style={{
                      fontSize: 14,
                      width: "100%",
                      float: "left",
                      textAlign: "left",
                      paddingLeft: 10,
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}> Request Data </span>
                  </span>
                </div>

                <Card
                  style={{ backgroundColor: "aliceblue", paddingBottom: 0 }}
                >
                  <CardBody style={{ padding: 8 }}>
                    <div style={{ width: "100%", float: "left" }}>
                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> EAN </span>
                        </span>
                        <input
                          type="text"
                          placeholder="EAN"
                          defaultValue={this.state.ean}
                          onChange={this.changeTesterQty}
                          disabled={true}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_ean == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> MRP </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Mrp"
                          value={this.state.mrp}
                          onChange={this.changeMrp}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_mrp == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Pack Size{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Pack Size"
                          value={this.state.autoPackSize}
                          onChange={this.onQuantityChangePackSize}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_packSize == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Variant </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Variant"
                          value={this.state.autoVariant}
                          onChange={this.onQuantityChangeVariant}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_variant == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          width: "13%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Shelf Life{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Shelf Life"
                          value={this.state.autoShelfLife}
                          onChange={this.onQuantityChangeShelf}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_shelf == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "15%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Product Name{" "}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Product Name"
                          value={this.state.autoProductName}
                          onChange={this.changeProductName}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_product == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          width: "12%",
                          float: "left",
                          textAlign: "left",
                        }}
                      >
                        <span
                          style={{ fontSize: 13, width: "100%", float: "left" }}
                        >
                          <span style={{ fontWeight: "bold" }}> Tax % </span>
                        </span>
                        <input
                          type="text"
                          placeholder="Tax Percentage"
                          value={this.state.tax_percentage1}
                          onChange={this.onQuantityChangeTax}
                          style={{
                            padding: 4,
                            borderRadius: 2,
                            width: "90%",
                            borderColor: "#dddddd",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            color:
                              this.state.color_tax == true
                                ? "orange"
                                : "inherit",
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>

                {/*<div style={{width: '100%', float: 'left'}}>
                
              <div style={{width: '16%', float:'left',textAlign: 'left'}}>
              <span style={{fontSize: 15, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> EAN </span></span>
                <input
                  type="text"
                  placeholder="EAN"
                  defaultValue={this.state.ean}
                  onChange={this.changeTesterQty}
                  disabled= {true}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "80%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div style={{width: '13%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Mrp </span></span>
                 <input
                  type="text"
                  placeholder="Mrp"
                  defaultValue={this.state.mrp}
                  onChange={this.changeMrp}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "60%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div style={{width: '14%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15 , width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Pack Size </span></span>
                 <input
                  type="text"
                  placeholder="Pack Size"
                  disabled={this.state.disabledPackSize}
                  value={this.state.packSize}
                  onChange={this.onQuantityChangePackSize}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "70%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div style={{width: '16%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Variant </span></span>
                 <input
                  type="text"
                  placeholder="Variant"
                  disabled={this.state.disabledVariant}
                  value={this.state.variant}
                  onChange={this.onQuantityChangeVariant}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "80%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>

              <div style={{width: '14%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Shelf Life </span></span>
                 <input
                  type="text"
                  placeholder="Shelf Life"
                  disabled={this.state.disabledShelfLife}
                  value={this.state.shelf_life}
                  onChange={this.onQuantityChangeShelf}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "70%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>
               <div style={{width: '21%', float:'left',textAlign: 'left'}}>
                <span style={{fontSize: 15, width:'100%', float: 'left'}}><span style={{fontWeight: 'bold'}}> Product Name </span></span>
                 <input
                  type="text"
                  placeholder="Product Name"
                  disabled={this.state.disabledProduct}
                  value={this.state.autoProductName}
                  onChange={this.changeProductName}
                  style={{
                    padding: 4,
                    borderRadius: 2,
                    width: "100%",
                    borderColor: "#dddddd",
                    borderWidth: "1px",
                    borderStyle: "solid",
                  }}
                />
              </div>
              </div>*/}
              </div>
            )}

            <div style={{ width: "100%", float: "left", marginTop: 12 }}>
              <ButtonToolbar className="modal__footer">
                <Button
                  style={{ backgroundColor: "#ddd", color: "#fff" }}
                  className="modal_ok"
                  onClick={this.toggle2}
                >
                  Cancel
                </Button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.onConfirmProduct}
                >
                  {this.state.ShowEditLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Confim
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal isOpen={SuccessConfirmmodal} toggle={this.SuccessConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccessConfirmoktoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
